const events = {};
export default ({ action, category, isHdp, label, unique, ...options }) => {
  if (unique) {
    if (events[action]) {
      return;
    }
    events[action] = true;
  }

  // eslint-disable-next-line no-unused-expressions
  global?.dataLayer?.push?.({
    event: "custom_event",
    event_action: action ?? "building_expert_event",
    event_category: category ?? (isHdp ? "sales_show" : "buildings_show"),
    event_label: label,
    ...options
  });
};
